import {useTrans} from '@ui/i18n/use-trans';
import {useAuth} from '@common/auth/use-auth';
import {UserAvatar} from '@common/auth/user-avatar';
import {NavbarAuthMenu} from '@common/ui/navigation/navbar/navbar-auth-menu';
import {Badge} from '@ui/badge/badge';
import {ButtonBase} from '@ui/buttons/button-base';
import {ListboxItemProps} from '@ui/forms/listbox/item';
import {ArrowDropDownIcon} from '@ui/icons/material/ArrowDropDown';
import {ReactElement} from 'react';

export interface NavbarAuthUserProps {
  items?: ReactElement<ListboxItemProps>[];
  variant?: 'wide' | 'compact';
  wideAvatarSize?: string;
  compactAvatarSize?: string;
}
export function NavbarAuthUser({
  items = [],
  variant = 'wide',
  wideAvatarSize = 'w-8 h-8',
  compactAvatarSize = 'w-6.5 h-6.5',
}: NavbarAuthUserProps) {
  const {trans} = useTrans();

  const {user} = useAuth();
  if (!user) return null;
  const hasUnreadNotif = !!user.unread_notifications_count;

  const avatar = (
    <UserAvatar
      user={user}
      circle
      fallback="initials"
      withLink={false}
      size={variant === 'wide' ? wideAvatarSize : compactAvatarSize}
    />
  );

  const compactButton = (
    <ButtonBase
      aria-label={trans({message: 'toggle authentication menu'})}
      display="block"
    >
      {avatar}
      {hasUnreadNotif ? (
        <Badge>{user.unread_notifications_count}</Badge>
      ) : undefined}
    </ButtonBase>
  );
  const wideButton = (
    <ButtonBase className="flex items-center" display="flex">
      {avatar}
      <span className="mr-0.5 ml-3 block max-w-31 overflow-x-hidden text-sm text-ellipsis">
        {user.name}
      </span>
      <ArrowDropDownIcon className="icon-sm block" />
    </ButtonBase>
  );

  return (
    <NavbarAuthMenu items={items}>
      <span className="block">
        {variant === 'wide' ? wideButton : compactButton}
      </span>
    </NavbarAuthMenu>
  );
}
